import React from 'react';

import './check.scss';

import { Svg } from '~shared/ui';

export interface CheckBoxProps {
	label?: string;
	checked?: boolean;
	onChange?: (chk: boolean) => void;
	disabled?: boolean;
}

export const CheckBox: React.FC<CheckBoxProps> = ({ disabled, checked, onChange, label }) => {
	const handleClick = (event: React.MouseEvent) => {
		event.stopPropagation();
		if (!disabled && onChange) onChange(!checked);
	};

	return (
		<div className={`check ${disabled ? 'disabled' : ''}`} onClick={handleClick}>
			<input disabled={disabled} type="checkbox" checked={checked && !disabled} />
			<span className="check__dop">
				<Svg name="check" />
			</span>
			{label && <span className="check__txt">{label}</span>}
		</div>
	);
};
